/**
 * Compare two semantic version strings
 * @param v1 First version (e.g., "2.5.0")
 * @param v2 Second version (e.g., "2.6.0")
 * @returns 1 if v1 > v2, -1 if v1 < v2, 0 if equal
 */
export const compareVersions = (v1: string, v2: string): number => {
  if (!v1 || !v2) return 0;

  const v1parts = v1.split('.').map((p) => parseInt(p, 10) || 0);
  const v2parts = v2.split('.').map((p) => parseInt(p, 10) || 0);

  for (let i = 0; i < Math.max(v1parts.length, v2parts.length); i++) {
    const v1part = v1parts[i] || 0;
    const v2part = v2parts[i] || 0;

    if (v1part > v2part) return 1;
    if (v1part < v2part) return -1;
  }
  return 0;
};

/**
 * Check if store version is newer than current version
 * @param storeVersion Version from App Store
 * @param currentVersion Current app version
 * @returns true if store version is newer
 */
export const isNewerVersion = (storeVersion: string, currentVersion: string): boolean => {
  if (!storeVersion || !currentVersion) return false;
  return compareVersions(storeVersion, currentVersion) > 0;
};
